import React from 'react';
import Standalone from './standalone';

class Realtime extends React.Component {
    render() {
        if (this.props.enabled) {
            return <Standalone {...this.props}>{this.props.children}</Standalone>;
        }

        return this.props.children;
    }
}

export default Realtime;